import React from "react";
import { Input, Typography } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import colors from "../constants/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";

interface FileUploaderProps {
	fileName?: string;
	setFile: (fileAsString: string) => void;
	setFileName: (fileName: string) => void;
}

/**
 * Will display the file input html object and parse the file to string.
 * It will then use the callback methods to pass back both the string representation of the file as well as the name of the file.
 */
export const FileUploader = (props: FileUploaderProps) => {
	const [drag, setDrag] = React.useState(false);

	const onUpload = (file) => {
		try {
			props.setFileName(file.name);
			const reader = new FileReader();
			reader.readAsText(file);
			reader.onloadend = () => {
				props.setFile(reader.result!.toString());
			};
		} catch (ex) {
			console.log(ex);
		}
	};

	const handleFileSelect = (event) => {
		try {
			onUpload(event.target.files[0]);
		} catch (ex) {
			console.log(ex);
		}
	};

	const onDragOver = (isOver) => (e) => {
		e.preventDefault();
		e.stopPropagation();
		setDrag(isOver);
	};

	// Handle file drop
	const onDrop = (e) => {
		e.stopPropagation();
		e.preventDefault();
		console.log("dropped");
		const files = e.dataTransfer.files;
		console.log(files[0]);
		if (files && files.length > 0) {
			onUpload(files[0]);
		}
		setDrag(false);
	};
	return (
		<div>
			<div>
				<Input id="upload-file-button" hidden={true} type={"file"} name={"file"} onChange={handleFileSelect}></Input>
				<label htmlFor="upload-file-button" style={{ margin: "auto" }}>
					<div
						id="dropContainer"
						style={{
							border: "2px dashed gray",
							borderRadius: 5,
							backgroundColor: drag ? colors.gray300 : colors.gray100,
							minHeight: "100px",
							width: "300px",
							alignSelf: "center",
							margin: "auto",
							cursor: "pointer",
						}}
						onDrop={onDrop}
						onDragOver={onDragOver(true)}
						onDragEnter={onDragOver(true)}
						onDragLeave={onDragOver(false)}
						onMouseEnter={() => setDrag(true)}
						onMouseLeave={() => setDrag(false)}
					>
						{props.fileName ? (
							<FileCopyIcon style={{ margin: "auto", marginTop: 30 }} fontSize={"large"}></FileCopyIcon>
						) : (
							<AttachFileIcon style={{ margin: "auto", marginTop: 30 }} fontSize={"large"}></AttachFileIcon>
						)}
						<Typography style={{ overflow: "hidden", width: "100%" }} title={props.fileName}>
							{props.fileName}
						</Typography>
					</div>
				</label>
			</div>
		</div>
	);
};
